"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFilterChip = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FilterChipMixin = require("../../mixins/components/FilterChipMixin");
var _ToggleButton = require("../ToggleButton/ToggleButton");
var StyledFilterChip = /*#__PURE__*/(0, _styledComponents.default)(_ToggleButton.ToggleButton).withConfig({
  displayName: "StyledFilterChip",
  componentId: "c11n-8-107-0__sc-1b5ahaw-0"
})(["", ""], _FilterChipMixin.FilterChipMixin);
exports.StyledFilterChip = StyledFilterChip;